import React from 'react';


export default class  extends React.Component {

    constructor() {
        super()
        this.handleClick = this.handleClick.bind(this)
    }


    handleClick(e) {
        if (location.pathname.startsWith("/ecosystem/")) {

            e.preventDefault();

            const _event = new CustomEvent("itemClick", {
                detail: {
                    data: this.props.to
                },
                bubbles: true,
                cancelable: true
            });
            e.target.dispatchEvent(_event);

        }
    }


    render() {
        const url = this.props.to;

        return <a href={url} target="_blank" className={this.props.className}
                  onClick={this.handleClick} rel="noopener noreferrer">{this.props.children}</a>

    }


}